import { compassProducts } from "../../../data/entity_sets/compassProducts";
import { recentlyViewedProducts } from "../../../data/entity_sets/recentlyViewedProducts";
import {
  atcToastProducts,
  searchContinuousProducts,
} from "../../../data/entity_sets/searchAndToastProducts";
import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";

/** DOM id of the "More ideas you might like" section the FAB scrolls to. */
export const MORE_IDEAS_SECTION_ID = "saved-products-more-ideas";

export const MORE_IDEAS_COUNT = 30;

/**
 * Recommendation pool for "More ideas you might like": the home feed's
 * products plus the search and recently-viewed sets, de-duplicated, minus
 * anything the retailer has already saved.
 */
export const getMoreIdeasProducts = (
  excludedTokens: Set<string>,
  count: number = MORE_IDEAS_COUNT
): FaireProductEntity[] => {
  const seenTokens = new Set<string>();
  const pool = [
    ...compassProducts,
    ...searchContinuousProducts,
    ...atcToastProducts,
    ...recentlyViewedProducts,
  ];
  return pool
    .filter((product) => {
      if (excludedTokens.has(product.token) || seenTokens.has(product.token)) {
        return false;
      }
      seenTokens.add(product.token);
      return Boolean(product.imageUrl);
    })
    .slice(0, count);
};
